<template>
  <div class="shouyecontainer">
    <div class="bgsh">
      <el-carousel indicator-position="outside" height="38rem">
        <el-carousel-item>
          <img class="ban3324" src="@/assets/xxkc/ban1.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <img class="ban3324" src="@/assets/xxkc/ban2.jpg"/>
        </el-carousel-item>
        <el-carousel-item>
          <img class="ban3324" src="@/assets/xxkc/ban3.jpg"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="hweretete">
      <div class="kkdsfddd">
        <div class="gdsgsdf">
          <div class="nnn1">
            <div class="shangmian">
              <div class="title11">行业快讯</div>
              <div class="more1" @click="gohykxlist(1)">MORE>></div>
            </div>
            <div class="line111"></div>
            <div class="xiamian">
<!--              <img class="kkllee" src="@/assets/xxkc/sner.jpg"/>-->
              <div class="xiaright">
                <div class="neirong77" v-for="(item, index) in hangyekuaixuns">
                  <div class="mskdfdd"  @click="gotoHykxById(item.id)">
                    <p class="nnkkert zhengwen_grey meme ">{{item.biaoti}}</p>
                    <p class="nnkkert meme ">{{item.shijian}}</p>
<!--                    <p class="nnkkert zhengwen_grey meme ">{{item.shijian}}</p>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nnn2">
            <div class="shangmian">
              <div class="title11">协会介绍</div>
              <div class="more1"  @click="gotoGywm">MORE>></div>
            </div>
            <div class="line111"></div>
<!--            <div class="kkll haha" @click="gotoGywm" v-html="xiehuijieshao.conten">-->
            <div class="kkll haha" @click="gotoGywm">
              国际数据治理协会（简称：IDGA）是一家非盈利的全球性数据管理组织，脱胎于2015年成立的中国企业数据治理联盟，致力于基于实战角度的数据治理知识、方法以及实操的普及，凝聚行业力量打造最具实战性的数据治理生态圈。
              IDGA将始终围绕企事业单位开展数据治理相关服务，将中国的数据要素及治理最佳实践带向全球，将全球最佳实践带回中国，促进数据要素和治理能力的相互融通，实现数据要素全球共享。
            </div>
          </div>
        </div>
      </div>
      <div class="hhffdrr">
        <div class="lmler">
          <div class="kkdfkdker">
            <div class="nnn832432">
              <div class="shangmian">
                <div class="title11">知识普及</div>
                <div class="more1" @click="gohykxlist(3)">MORE>></div>
              </div>
              <div class="line111"></div>
              <div class="neirong77" v-for="(item,index) in zspjs" @click="gotoZspjById(item.id)">
                <p class="zhengwen43534534 meme kdkfllsd" >{{item.biaoti}}</p>
                <p class="meme ">{{item.shijian}}</p>
              </div>
            </div>
            <div class="nnn832432">
              <div class="shangmian">
                <div class="title11">协会动态</div>
                <div class="more1"></div>
              </div>
              <div class="line111"></div>
              <div class="llwere">
                <el-carousel indicator-position="outside">
                  <el-carousel-item v-for="(item,index) in xiehuidongtais">
                    <img class="jdsfsjhjsdgsd" :src="item.tupian">
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="nnn832432">
              <div class="shangmian">
                <div class="title11">经验杂谈</div>
                <div class="more1" @click="gohykxlist(2)">MORE>></div>
              </div>
              <div class="line111"></div>
              <div class="neirong77"  v-for="(item,index) in jingyanzatans" @click="gotoJyztById(item.id)">
                <p class="zhengwen43534534 meme kdkfllsd" >{{item.biaoti}}</p>
                <p class="meme ">{{item.shijian}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kkdsfddd">
        <div class="kkdfkdker">
          <div class="nnn832432">
            <div class="shangmian">
              <div class="title11">视频知识</div>
              <div class="more1" @click="gotoshipinlist()">MORE>></div>
            </div>
            <div class="line111"></div>
            <div class="uncvdfd">
              <div class="nnkdfe">
                <div class="nwerer" v-for="(item,index) in kechengfenlei">
                  <div class="vertical-line"></div>
                  <div @click="showKcjieshao(item)">{{item.dictname}}</div>
                </div>
              </div>
              <div class="uyebncfd">
                <div class="unoooee">
                  <p class="biaoti4">{{currentFenlei.dictname}}</p>
                  <div class="zhengwen_grey wzslh_wrap" v-html="currentFenlei.dictms">
                  </div>
                  <p class="meme" style="color: #0f7cf1" @click="gotoxianshang(currentFenlei)">查看更多>></p>
                </div>
                <img class="nerere" src="@/assets/xxkc/7676.jpg"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hweretete">
      <div  class="nkcet">
        <div class="shangmian">
          <div class="title11115">行业专家</div>
        </div>
      </div>
      <img class="kkcdsdf" src="@/assets/xxkc/3454.jpg"/>
      <div class="nnkeertt">
        <div class="ndfder" v-for="(item,index) in jiangshi" @click="gotoJiangshiById(item.zjname)">
          <img class="njjtt" :src="item.zjtx"/>
          <p class="nkk">{{item.zjname}}</p>
          <p class="nkkere">{{item.jianjie}}</p>
        </div>
      </div>
      <div class="anniu">
        <div class="btnddd" @click="gojiangshilist()">查看其他专家>></div>
      </div>
    </div>
    <div class="hweretete">
      <div class="kkdsfddd">
        <div class="kkdfkdker">
          <div class="nnn5">
            <div class="shangmian">
              <div class="title11">方案推荐</div>
              <div class="more1" @click="gosslist()">MORE>></div>
            </div>
            <div class="line111"></div>
            <img class="kkdkfn" src="@/assets/xxkc/8989.jpg"/>
            <div class="jiirrt">
              <ul >
                <li class="underline-li zhengwen_grey  meme" v-for="(item,index) in ssfas"  v-if="index < 3" @click="gotoShishixiangqing(item.id)">{{item.biaoti}}</li>
              </ul>
              <ul >
                <li class="underline-li zhengwen_grey  meme" v-for="(item,index) in ssfas"  v-if="index >= 3 && index <6 " @click="gotoShishixiangqing(item.id)">{{item.biaoti}}</li>
              </ul>
              <ul>
                <li class="underline-li zhengwen_grey  meme" v-for="(item,index) in ssfas" v-if="index >= 6 && index <9 " @click="gotoShishixiangqing(item.id)">{{item.biaoti}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dsfsdfg" v-model="fwcishu">【访问次数:{{fwcishu}}】</div>
  </div>
</template>
<script>
export default {
  name: 'HomePage',
  data() {
    return {
      zspjs: [],
      jingyanzatans: [],
      hangyekuaixuns: [],
      xiehuijieshao: {},
      kechengfenlei: [],
      currentFenlei: '',
      ssfas: [],
      jiangshi: [],
      xiehuidongtais: [],
      fwcishu:0
    };
  },
  mounted() {
    this.queryZspj();
    this.queryHyfx();
    this.queryJyzt();
    this.queryXiehui();
    this.queryKcfenlei();
    this.queryShishifangan();
    this.queryjiangshi();
    this.queryXiehuidongtais();

  },
  created() {
    this.tongji('首页');
  },
  methods: {
    tongji(caidan) {
      var that = this;
      this.$ajax
          .post(this.GLOBAL.sys_addr + '/tongji/tTongji/tj', {caidan: caidan})
          .then(function (response) {
            if (response.status == 200) {
              that.fwcishu = response.data;
            }
          });
    },
    gotoshipinlist() {
      this.$router.push({path: '/shipinzhishi'});
    },
    gotoxianshang(item) {
      this.$router.push({path:'/zlkc',query:{fenlei:item.dictname,dictms:item.dictms}});
    },
    showKcjieshao(item) {
      this.currentFenlei = item;
    },
    gotoGywm() {
      this.$router.push({path: '/guanyuwomen'});
    },
    gotoJiangshiById(zjname) {
      this.$router.push({path: '/jiangshijieshao', query: {name: zjname}});
    },
    gojiangshilist() {
      this.$router.push({path: '/jiangshijieshao'});
    },
    gosslist() {
      this.$router.push({path: '/shishifangan'});
    },
    gohykxlist(type) {
      this.$router.push({path: '/xgzs', query: {type: type}});
    },
    gotoShishixiangqing(id) {
      this.$router.push({path: '/ssxq', query: {id: id}});
    },
    gotoHykxById(id) {
      this.$router.push({path: '/zspj', query: {id: id, type: 1, from: 'shouye'}});
    },
    gotoJyztById(id) {
      this.$router.push({path: '/zspj', query: {id: id, type: 2, from: 'shouye'}});
    },
    gotoZspjById(id) {
      this.$router.push({path: '/zspj', query: {id: id, type: 3, from: 'shouye'}});
    },
    queryXiehuidongtais() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/xiehuidongtai/tXiehuidongtai/list?_t=' + new Date().getTime() + '&column=xh&order=desc&pageNo=' + 0 + '&pageSize=' + 8)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.xiehuidongtais = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryjiangshi() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/zhuanjia/tZhuanjia/list?_t=' + new Date().getTime() + '&column=pxh&order=asc&pageNo=' + 0 + '&pageSize=' + 5)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.jiangshi = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryShishifangan() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/shishi/tShishifangan/list?_t=' + new Date().getTime() + '&column=pxh&order=desc&pageNo=' + 0 + '&pageSize=' + 9)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.ssfas = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryKcfenlei() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/tdict/tDict/list?_t=' + new Date().getTime() + '&column=id&order=asc&groupname=学习内容&pageNo=' + 0 + '&pageSize=' + 8)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.kechengfenlei = response.data.result.records;
              that.currentFenlei = that.kechengfenlei[0];
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryXiehui() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/gywm/tGywm/list?_t=' + new Date().getTime() + '&column=id&order=asc&field=id,biaoti,action&pageNo=' + 0 + '&pageSize=' + 1)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.xiehuijieshao = response.data.result.records[0];
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryZspj() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t=' + new Date().getTime() + '&column=paixu&order=desc&field=id,biaoti,action&fenlei=知识普及&pageNo=' + 0 + '&pageSize=' + 7)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.zspjs = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryJyzt() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t=' + new Date().getTime() + '&column=paixu&order=desc&field=id,biaoti,action&fenlei=经验杂谈&pageNo=' + 0 + '&pageSize=' + 7)
          .then(function (response) {
            if (response.data.code == 200) {
              that.jingyanzatans = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
    queryHyfx() {
      var that = this;
      this.$ajax
          .get(this.GLOBAL.sys_addr + '/wenben/tWenben/list?_t=' + new Date().getTime() + '&column=paixu&order=desc&field=id,biaoti,action&fenlei=行业快讯&pageNo=' + 0 + '&pageSize=' + 5)
          .then(function (response) {
            if (response.data.code == 200) {
              debugger
              that.hangyekuaixuns = response.data.result.records;
            } else {
              that.$notify.warning({position: 'bottom-right', title: '提示', message: response.data.msg});
            }
          });
    },
  }
};
</script>

<style  scoped>
.shouyecontainer {
  width: 100%;
}

.bgsh {
  width: 100%;
  background-size: cover; /* 或contain */
  background-position: center;
  background-repeat: no-repeat;
}
.gdsgsdf {
  width: 100%;
  display: flex;
}
.kkdfkdker {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.nnn1{
  width: 60%;
  margin: 1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 1rem;

}
.nnn2{
  width: 40%;
  margin:1rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 1rem;
}
.nnn5{
  margin: 1rem 1rem;
  width: 100%;
  //border:1px solid #8a8a8a;

  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 1rem;
}

.shangmian{
  padding: 0.5rem 0rem 0rem 0rem;
  display: flex;
  justify-content: space-between;
}
.line111{
  //display: block;
  //margin: 0;
  //margin-top: -1.5px;
  //padding: 0;
  //top: 50%;
  //width: 100%;
  //height: 1px;
  //font-size: 0;
  //border-bottom-width: 3px;
  //border-bottom-style: solid;
  //border-bottom-color: #0f91e7;
  //-moz-box-shadow: 0 0 0 transparent;
  //-webkit-box-shadow: 0 0 0 transparent;
  //-ms-box-shadow: 0 0 0 transparent;
  //-o-box-shadow: 0 0 0 transparent;
  //box-shadow: 0 0 0 transparent;
}
.title11{
  font-size: 1rem;
  font-weight: bold;
  color: #0f91e7;
}
.title11115{
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  color: #0f91e7;
  text-align: center;
  margin-bottom: 1rem;
}
.more1{
  color: #0f91e7;
}
.more1:hover{
  cursor: pointer;
  font-size: 14px;
}
.xiamian{
  display: flex;
  gap: 1rem;
}
.xialeft{
  width: 40%;
  padding: 0.5rem;
  display: flex;
  gap: 1rem;
}
.jnkld{

}
.kkllee{
  width: 20rem;
  height: 15rem;
  object-fit: cover;
}

.neirong77{
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  line-height: 27px;
}
.neirong77:hover{
  cursor: pointer;
  text-decoration: underline;
  color: #0f7cf1;;
}
.wenzirrr{

}
.nnn832432{
  width: 100%;
  margin: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.llwere{
  width: 100%;
}
.ban3324{
  width: 100%;
  height: 100%;
}
.nnkdfe{
  width: 15%;
  display: flex;
  gap: 1rem;
  flex-direction: column;
}
.nwerer{
  display: flex;
  gap: 5px;
  line-height: 20px;
}
.nwerer:hover{
  color: #0f7cf1;
  cursor: pointer;
}
.nwerer23{

}
/deep/.el-carousel__container {
	position: relative;
	height: 280px;
	width:100%;
}
.vertical-line {
  width: 10px; /* 或者你需要的任何宽度 */
  height: 20px; /* 或者你需要的任何高度 */
  line-height: 20px;
  background-color: transparent; /* 确保背景是透明的，只显示边框 */
  border-left: 3px solid #0c0c0c; /* 设置左边框为竖线 */
  border-radius: 1px;
  display: flex;
}
.kkweret{
  height: 20px;
  line-height: 20px;
  font-size: 1rem;
}
.kkdsfddd{
  width: 70%;
}
.hhffdrr{
  width: 100%;
  background-image: url('../../assets/xxkc/qianse1.png');
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.lmler{
  width: 70%;

}
.hweretete{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  margin-bottom:3rem;
}
.uncvdfd{
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
}
.uyebncfd{
  width: 85%;
  background-color: #f4f4f4;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
}
.nerere{
  width: 30%;
}
.unoooee{
  display: flex;
  flex-direction: column;
  padding: 1.2rem;
  gap:0.3rem;
}
.kkcdsdf{
  width: 100%;
  height: 22rem;
}

.ndfder{
  width: 18rem;
  height: 20rem;
  //background-color: #e2f4fc;
  background-color: #ffffff;
  border: 1px solid #eeeded;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0;
  justify-content: center;
  align-items: center;
  //box-shadow: 0px 0px 10px 1px #9d9e9f;
}
.anniu{
  width: 70%;
  display: flex;
  justify-content: center;
}
.btnddd{
  height: 2rem;
  width: 13rem;
  border: 1px solid #0f91e7;
  border-radius: 1rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  color: #0f91e7;
}
.btnddd:hover{
  cursor: pointer;
  height: 2rem;
  width: 13rem;
  border: 1px solid #0863ee;
  border-radius: 1rem;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  color: #0863ee;
}
.nnkeertt{
  width: 80%;
  margin-top: -10rem;
  display: flex;
  gap: 1rem;
  padding: 1rem;
  justify-content: space-evenly;
}
.nkk{
  text-align: center;
  font-size: 1.5rem;
  margin-top: 1rem;
  font-weight: bold;
}
.nkkere{
  text-align: center;
  font-size: 14px;
  margin-top: 1.5rem;
}
.ndfder:hover{
  cursor: pointer;
  box-shadow: 0px 0px 10px 1px #989999;
}
.njjtt{
  width: 10rem;
  height: 10rem;
}
.nkcet{
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.kkdkfn{
  height: 50%;
}
/* 方法1：使用text-decoration */
.underline-li {
  text-decoration: underline;
  padding: 5px;
  letter-spacing: 2px;
}

/* 方法2：使用border-bottom */
.border-li {
  border-bottom: 1px solid #000;
  display: inline-block; /* 如果想让下划线只跟文字宽度相同 */
}

/* 方法3：使用伪元素 */
.pseudo-li {
  position: relative;
}
.pseudo-li::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 100%;
  height: 1px;
  background: #000;
}
.jiirrt{
  display: flex;
  gap: 2rem;
  justify-content: space-between;
}
.mskdfdd{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mskdfdd:hover{
  cursor: pointer;
  text-decoration: underline;
  color: #0f7cf1;;
}

.nnkkert{
}

.meme:hover{
  color:#0f7cf1;
  cursor: pointer;
  text-decoration: underline;

}
.haha:hover{
  cursor: pointer;
  text-decoration: underline;
}
.xiaright{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.92rem;
}
.kkll{
  font-size: 14px;
  letter-spacing: 0.2rem;
  line-height: 2.1rem;
  width: 100%;             /* 必须有明确宽度 */
  //display: flex;
  //flex-wrap: wrap;
  //height: 15rem;
  //justify-content: space-between;
  //text-align: justify;
  //text-align-last: justify;

  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

}
.zhengwen43534534{
  width: 50%;
  font-size: 14px;
  letter-spacing: 0.2rem;
}
.kdkfllsd{
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 隐藏溢出内容 */
  text-overflow: ellipsis;  /* 显示省略号 */
}
.jdsfsjhjsdgsd{
  width: 100%;
  height: 100%;
}
</style>
